module.exports = __webpack_public_path__ + "img/new-tsgn_tab5.48d62e46.png";